<template>
  <div>
  <div id="editorjs"> </div>
  </div>
</template>
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/header@latest"></script>&lt;!&ndash; Header &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/simple-image@latest"></script>&lt;!&ndash; Image &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/delimiter@latest"></script>&lt;!&ndash; Delimiter &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/list@latest"></script>&lt;!&ndash; List &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/checklist@latest"></script>&lt;!&ndash; Checklist &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/quote@latest"></script>&lt;!&ndash; Quote &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/code@latest"></script>&lt;!&ndash; Code &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/embed@latest"></script>&lt;!&ndash; Embed &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/table@latest"></script>&lt;!&ndash; Table &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/link@latest"></script>&lt;!&ndash; Link &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/warning@latest"></script>&lt;!&ndash; Warning &ndash;&gt;-->

<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/marker@latest"></script>&lt;!&ndash; Marker &ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/@editorjs/inline-code@latest"></script>&lt;!&ndash; Inline Code &ndash;&gt;-->
<script>

import router from "../../main";
import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import SimpleImage from '@editorjs/simple-image';
import Checklist from '@editorjs/checklist';
import Quote from '@editorjs/quote';
import Warning from '@editorjs/warning';
import Marker from '@editorjs/marker';
import CodeTool from '@editorjs/code';
import Delimiter from '@editorjs/delimiter';
import InlineCode from '@editorjs/inline-code';
import LinkTool from '@editorjs/link';
import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import List from '@editorjs/list';
import ImageTool from '@editorjs/image';



const url = process.env.VUE_APP_API_BASE_URL;
import axios from 'axios';


export default {
  data() {
    return {}
  },
  components: {},
  methods: {},
  mounted() {
    const options = {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      }
    };
    // axios.get(`${url}/premontage-pdfs`, options)
    //     .then(response => {
    //         console.log(response)
    //     });

    const editor = new EditorJS({
      /**
       * Id of Element that should contain the Editor
       */
      holder: 'editorjs',

      /**
       * Available Tools list.
       * Pass Tool's class or Settings object for each Tool you want to use
       */
      tools: {
        /**
         * Each Tool is a Plugin. Pass them via 'class' option with necessary settings {@link docs/tools.md}
         */
        // header: {
        //   class: Header,
        //   inlineToolbar: ['marker', 'link'],
        //   config: {
        //     placeholder: 'Header'
        //   },
        //   shortcut: 'CMD+SHIFT+H'
        // } ,


        /**
         * Or pass class directly without any configuration
         */

        // image: {
        //   class: SimpleImage,
        //   inlineToolbar: true,
        //   config: {
        //     placeholder: 'Paste image URL'
        //   }  },
        image: {
          class: ImageTool,
          config: {
            endpoints: {
              byFile: 'http://localhost:8008/uploadFile', // Your backend file uploader endpoint
              byUrl: 'http://localhost:8008/fetchUrl', // Your endpoint that provides uploading by Url
            }
          }
        }

        // list: {
        //   class: List,
        //   inlineToolbar: true,
        //   shortcut: 'CMD+SHIFT+L'
        // },
        //
        // checklist: {
        //   class: Checklist,
        //   inlineToolbar: true,
        // },
        //
        // quote: {
        //   class: Quote,
        //   inlineToolbar: true,
        //   config: {
        //     quotePlaceholder: 'Enter a quote',
        //     captionPlaceholder: 'Quote\'s author',
        //   },
        //   shortcut: 'CMD+SHIFT+O'
        // },
        //
        // warning: Warning,
        //
        // marker: {
        //   class:  Marker,
        //   shortcut: 'CMD+SHIFT+M'
        // },
        //
        // code: {
        //   class:  CodeTool,
        //   shortcut: 'CMD+SHIFT+C'
        // },
        //
        // delimiter: Delimiter,
        //
        // inlineCode: {
        //   class: InlineCode,
        //   shortcut: 'CMD+SHIFT+C'
        // },
        //
        // linkTool: LinkTool,
        //
        // embed: Embed,
        //
        // table: {
        //   class: Table,
        //   inlineToolbar: true,
        //   shortcut: 'CMD+ALT+T'
        // },

      },

      i18n: {
        /**
         * @type {I18nDictionary}
         */
        messages: {
          /**
           * Other below: translation of different UI components of the editor.js core
           */
          ui: {
            "blockTunes": {
              "toggler": {
                "Click to tune": "Modifier",
                "or drag to move": "glisser pour deplacer"
              },
            },
            "inlineToolbar": {
              "converter": {
                "Convert to": "Convertir"
              }
            },
            "toolbar": {
              "toolbox": {
                "Add": "Ajout",
                "Nothing found":"Aucun resultat",
                "Filter":"Filtre"
              }
            }
          },

          /**
           * Section for translation Tool Names: both block and inline tools
           */
          toolNames: {
            "Text": "Texte",
            "Heading": "Titre",
            "List": "Liste",
            "Warning": "Attention",
            "Checklist": "Liste à cocher",
            "Quote": "Quote",
            "Code": "Code",
            "Delimiter": "Délimiteur",
            "Raw HTML": "HTML",
            "Table": "Table",
            "Link": "Lien",
            "Marker": "Marker",
            "Bold": "Gras",
            "Italic": "Italic",
            "InlineCode": "InlineCode",

          },

          /**
           * Section for passing translations to the external tools classes
           */
          tools: {
            /**
             * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
             * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
             */
            "warning": { // <-- 'Warning' tool will accept this dictionary section
              "Title": "Название",
              "Message": "Сообщение",
            },

            /**
             * Link is the internal Inline Tool
             */
            "link": {
              "Add a link": "Ajouter un lien"
            },
            /**
             * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
             */
            "stub": {
              'The block can not be displayed correctly.': 'Ce bloc ne peut être afficher correctement'
            }
          },

          /**
           * Section allows to translate Block Tunes
           */
          blockTunes: {
            /**
             * Each subsection is the i18n dictionary that will be passed to the corresponded Block Tune plugin
             * The name of a plugin should be equal the name you specify in the 'tunes' section for that plugin
             *
             * Also, there are few internal block tunes: "delete", "moveUp" and "moveDown"
             */
            "delete": {
              "Delete": "Supprimer"
            },
            "moveUp": {
              "Move up": "Déplacer vers le haut"
            },
            "moveDown": {
              "Move down": "Déplacer vers le bas"
            }
          },
        }
      }
    })
  }
}
</script>
<style>

</style>
